<!--
 * @Description: 学生 详情 家庭成员
 * @Author: PF
 * @Date: 2023-11-30 10:20:27
 * @LastEditors: PF
 * @LastEditTime: 2025-07-16 17:51:21
-->
<template>
  <div class="hp100" v-loading="loading">
    <ul class="jtcy-page" v-if="tableData.length">
      <li v-for="(item, index) in tableData" :key="index">
        <div class="tit"><span style="color: #67C23A;margin-right: 5px;">●</span>{{ item.xm }}</div>
        <div>{{ item.gx }}、{{ item.jtcyzy }}、{{ item.zzmmbt }}</div>
        <div>{{ item.dh }}、{{ item.yddh }}</div>
        <div>{{ item.szdw }}</div>
      </li>
    </ul>
    <el-empty v-else class="hp100" description="未录入家庭成员" />
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common'

const props = defineProps({
  row: { type: Object, required: false }
})
const loading = ref(false)
const tableData = ref([])

watch(
  () => props.row,
  () => {
    if (props.row) {
      loading.value = true
      const o = { url: `/api/v2/pdp/xuesheng/${props.row.id}`, data: {} }
      actionPost(o).then((res) => {
        tableData.value = res.data.jtcyList || []
        loading.value = false
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
  .jtcy-page{
    display: flex;
    justify-content: space-between;
    li {
      color: #909399;
      border: 1px solid #e7e7e7;
      border-radius: 10px;
      padding: 10px;
      margin-top: 10px;
      width: calc(50% - 5px);
      .tit {
        color: #303133;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
</style>